import { createAction } from '@reduxjs/toolkit';
export const clearFilterValues = createAction('clearFilterValues');
export const clearSearchValue = createAction('clearSearchValue');
export const clearSearchAndFilterValues = createAction('clearSearchAndFilterValues');
export const setFilterValue = createAction('setFilterValue', payload => ({
  payload
}));
export const setFilterValues = createAction('setFilterValues', payload => ({
  payload
}));